import { parseQuery } from '~/lib/mq';

import { useMatchMedia } from './use-match-media';

export function useBreakpoint(breakpoint: string, defaultValue?: boolean) {
  return useMatchMedia(parseQuery(breakpoint), defaultValue);
}
